export const alphanumeric = {
    mounted(el) {
        el.addEventListener("keydown", function (event) {
            if (event.key === "Backspace" || event.key === "Delete") {
                return;
            }

            if (!/[0-9a-zA-Z/\s]/i.test(event.key)) {
                event.preventDefault();
            }
        });

        el.addEventListener("paste", function (event) {
            event.preventDefault();

            const target = event.target;

            const clipboardData =
                event.clipboardData || window.clipboardData;

            const pastedText = clipboardData.getData("text");

            // Allow only alphanumeric, spaces and /
            if (/^[a-zA-Z0-9/\s]+$/.test(pastedText)) {
                const start = target.selectionStart;
                const end = target.selectionEnd;

                const currentValue = target.value;

                // Replace selected text with pasted text
                const maxLength = target.maxLength;
                const availableLength =
                    maxLength >= 0
                        ? maxLength - (currentValue.length - (end - start))
                        : pastedText.length;
                const textToInsert = pastedText.slice(
                    0,
                    Math.max(0, availableLength)
                );
                target.value =
                    currentValue.substring(0, start) +
                    textToInsert +
                    currentValue.substring(end);

                // Set cursor after pasted text
                const newCursorPosition = start + textToInsert.length;

                target.setSelectionRange(
                    newCursorPosition,
                    newCursorPosition
                );

                // Notify Vue about the value change
                target.dispatchEvent(new Event("input", { bubbles: true }));
            }
        });
    },
};

export const shareholderpercent = {
  mounted(el) {
    const isValidFinalValue = (value) => {
      if (value === "") return false;
      // Must be: 0.xx OR whole/decimal starting with 1-9
      if (!/^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/.test(value)) return false;
      const num = parseFloat(value);
      return num >= 0.01 && num <= 100;
    };
    const isValidIntermediateValue = (value) => {
      if (value === "") return true;
      // Block leading zeros like "00", "01", "09" — only "0" alone or "0." is ok
      if (value[0] === "0" && value.length > 1 && value[1] !== ".") return false;
      // Allow "0" alone as intermediate (user about to type ".")
      if (value === "0") return true;
      // Allow "0." as intermediate
      if (value === "0.") return true;
      // Allow "0.x" or "0.xx"
      if (/^0\.\d{1,2}$/.test(value)) return parseFloat(value) <= 100;
      // Allow trailing dot for 1-9 start (e.g. "1.", "12.")
      if (/^[1-9]\d*\.$/.test(value)) return true;
      // Allow digits with up to 2 decimal places starting with 1-9
      if (/^[1-9]\d*(\.\d{0,2})?$/.test(value)) return parseFloat(value) <= 100;
      return false;
    };

    el.addEventListener("keydown", (event) => {
      const allowedKeys = [
        "Backspace", "ArrowLeft", "ArrowRight", "ArrowUp",
        "ArrowDown", "Tab", "Home", "End", "Delete",
      ];

      const isNumeric = /^[0-9]$/.test(event.key);
      const isDot = event.key === "." || event.key === "Decimal";
      const isAllowedKey = allowedKeys.includes(event.key);
      const isCtrlCombo =
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].includes(event.key.toLowerCase());

      if (!isNumeric && !isDot && !isAllowedKey && !isCtrlCombo) {
        event.preventDefault();
        return;
      }

      const current = el.value;
      const selectionStart = el.selectionStart;
      const selectionEnd = el.selectionEnd;

      if (isDot) {
        // Block if field is empty
        if (current === "" && selectionStart === 0) {
          event.preventDefault();
          return;
        }
        // Block if there's already a dot
        if (current.includes(".")) {
          event.preventDefault();
          return;
        }
        // Block leading dot (nothing before cursor)
        if (selectionStart === 0 && selectionEnd === 0) {
          event.preventDefault();
          return;
        }
        return;
      }

      if (isNumeric) {
        const newValue =
          current.slice(0, selectionStart) + event.key + current.slice(selectionEnd);
        if (!isValidIntermediateValue(newValue)) {
          event.preventDefault();
        }
      }
    });

    el.addEventListener("blur", () => {
      const value = el.value.trim();
      if (value === "") return;

      // Clear if not a valid final value (catches "0", "1.", "0.", etc.)
      if (!isValidFinalValue(value)) {
        el.value = "";
        el.dispatchEvent(new Event("input"));
        return;
      }

      if (parseFloat(value) > 100) {
        el.value = "100";
        el.dispatchEvent(new Event("input"));
      }
    });

    el.addEventListener("paste", (event) => {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData("text");
      const current = el.value || "";
      const selectionStart = el.selectionStart;
      const selectionEnd = el.selectionEnd;
      const newValue =
        current.slice(0, selectionStart) + paste + current.slice(selectionEnd);

      if (isValidIntermediateValue(newValue)) {
        document.execCommand("insertText", false, paste);
      }
    });

    el.addEventListener("drop", (event) => {
      event.preventDefault();
      const text = event.dataTransfer.getData("text");
      const current = el.value || "";
      const newValue = current + text;

      if (isValidIntermediateValue(newValue)) {
        document.execCommand("insertText", false, text);
      }
    });
  },
};

export const nameAlphanumeric = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const isBackspaceKey = event.key === "Backspace";
      if (isBackspaceKey) {
        return true;
      }
      
      // Allow alphanumeric, space, @, -, /, comma, and period
      if (!/[0-9a-zA-Z@\-/,.\s]/i.test(event.key)) {
        event.preventDefault();
      }
    });
    
    el.addEventListener("paste", function (event) {
            event.preventDefault();

            const clipboardData =
                event.clipboardData || window.clipboardData;

            const pastedText = clipboardData.getData("text");
            // Allow alphanumeric, space, @, -, /, comma, and period
            if (/^[a-zA-Z0-9@\-/,.\s]+$/.test(pastedText)) {
                const start = el.selectionStart;
                const end = el.selectionEnd;

                const currentValue = el.value;

                // Replace selected text with pasted text
                const maxLength = el.maxLength;
                 const availableLength =
                     maxLength >= 0
                         ? maxLength - (currentValue.length - (end - start))
                         : pastedText.length;
                 const textToInsert = pastedText.slice(
                     0,
                     Math.max(0, availableLength)
                 );
                el.value =
                    currentValue.substring(0, start) +
                    textToInsert +
                    currentValue.substring(end);

                // Set cursor after pasted text
                const newCursorPosition = start + textToInsert.length;

                el.setSelectionRange(
                    newCursorPosition,
                    newCursorPosition
                );

                // Notify Vue about the value change
                el.dispatchEvent(new Event("input", { bubbles: true }));
            }
        });
  },
};
export const alphanumericWithoutSpace = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const isBackspaceKey = event.key === "Backspace";
      if (isBackspaceKey) {
        return true;
      }
      if (!/[0-9a-zA-Z]/i.test(event.key)) {
        event.preventDefault();
      }
    });
    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      // Check if the pasted text contains only alphanumeric characters
      if (/^[a-zA-Z0-9]+$/.test(pastedText)) {
        // If it's alphanumeric, set the input value
        el.value = el.value + pastedText;
        el.dispatchEvent(new Event("input"));
      }
    });
  },
};
export const embossedname = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const isBackspaceKey = event.key === "Backspace";
      if (isBackspaceKey) {
        return true;
      }
      if (!/[0-9a-zA-Z\s]/i.test(event.key)) {
        event.preventDefault();
      }
    });
    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      // Check if the pasted text contains only alphanumeric characters
      if (/^[a-zA-Z0-9\s]+$/.test(pastedText)) {
        // If it's alphanumeric, set the input value
        el.value = el.value + pastedText;
        el.dispatchEvent(new Event("input"));
      }
    });
  },
};
export const numeric = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const allowedKeys = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
        "Delete",
      ];

      const isNumeric = /^[0-9]$/.test(event.key);
      const isAllowedKey = allowedKeys.includes(event.key);

      // Allow: Ctrl/Meta + [a, c, v, x]
      const isCtrlCombo =
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].includes(event.key.toLowerCase());

      // Allow numbers, allowed keys, or valid Ctrl/Meta combos
      if (!isNumeric && !isAllowedKey && !isCtrlCombo) {
        event.preventDefault();
      }
    });

    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      const numericOnly = pastedText.replace(/\D/g, "").slice(0, 10);

      el.value = numericOnly;

      // Trigger input event so Vue picks up the change
      el.dispatchEvent(new Event("input", { bubbles: true }));
    });
  },
};
export const bankAccount = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const allowedKeys = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
        "Delete",
      ];

      const isNumeric = /^[0-9]$/.test(event.key);
      const isAllowedKey = allowedKeys.includes(event.key);

      // Allow: Ctrl/Meta + [a, c, v, x]
      const isCtrlCombo =
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].includes(event.key.toLowerCase());

      // Allow numbers, allowed keys, or valid Ctrl/Meta combos
      if (!isNumeric && !isAllowedKey && !isCtrlCombo) {
        event.preventDefault();
      }
    });

    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      const numericOnly = pastedText.replace(/\D/g, "")

      el.value = numericOnly;

      // Trigger input event so Vue picks up the change
      el.dispatchEvent(new Event("input", { bubbles: true }));
    });
  },
};
export const alphabet = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const isBackspaceKey = event.key === "Backspace";
      if (isBackspaceKey) {
        return true;
      }
      if (!/[a-zA-Z]/i.test(event.key)) {
        event.preventDefault();
      }
    });
    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      // Check if the pasted text contains only alphabetic characters
      if (/^[a-zA-Z]+$/.test(pastedText)) {
        // If it's alphabetic, set the input value
        el.value = el.value + pastedText;
        el.dispatchEvent(new Event("input"));
      }
    });
  },
};

export const twodigitdecimal = {
  mounted(el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (!input) return;

    el._twoDecimalInput = input;
    el._lastValid = input.value || "";
    const DECIMAL_REGEX = /^\d*\.?\d{0,2}$/;
    el._twoDecimalHandler = () => {
      if (input.validity && input.validity.badInput) return;

      if (DECIMAL_REGEX.test(input.value)) {
        el._lastValid = input.value;
        return;
      }

      input.value = el._lastValid;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    };

    input.addEventListener("input", el._twoDecimalHandler);
  },

  unmounted(el) {
    el._twoDecimalInput?.removeEventListener("input", el._twoDecimalHandler);
  },
};
// export const twodigitdecimal = {
//   mounted(el) {
//     el.addEventListener('keydown', (event) => {
//       const allowedKeys = [
//         'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', // Arrow keys
//         'Backspace', 'Tab', 'Delete', 'Home', 'End' // Navigation keys
//       ];

//       // Allow navigation keys without validation
//       if (allowedKeys.includes(event.key)) {
//         return true;
//       }

//       // Allow only numbers, decimal point, and restrict multiple decimals
//       const inputValue = event.target.value;

//       if ((event.key >= '0' && event.key <= '9') || (event.key === '.' && !inputValue.includes('.'))) {
//         return true; // Allow number and one decimal point
//       }

//       // Block any other keys (like letters)
//       event.preventDefault();
//     });
//   }
// }

export const phoneNumber = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const allowedKeys = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
        "Delete",
      ];

      const isNumeric = /^[0-9]$/.test(event.key);
      const isAllowedKey = allowedKeys.includes(event.key);

      // Allow: Ctrl/Meta + [a, c, v, x]
      const isCtrlCombo =
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].includes(event.key.toLowerCase());

      // Allow numbers, allowed keys, or valid Ctrl/Meta combos
      if (!isNumeric && !isAllowedKey && !isCtrlCombo) {
        event.preventDefault();
      }

      // Prevent typing more than 10 digits
      if (el.value.length >= 10 && isNumeric) {
        event.preventDefault();
      }
    });

    el.addEventListener("paste", function (event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      const numericOnly = pastedText.replace(/\D/g, "").slice(0, 10);

      el.value = numericOnly;

      // Trigger input event so Vue picks up the change
      el.dispatchEvent(new Event("input", { bubbles: true }));
    });
  },
};

export const businessRegNumber = {
  mounted(el) {
    el.addEventListener("keydown", function (event) {
      const isBackspaceKey = event.key === "Backspace";
      if (isBackspaceKey) {
        return true;
      }
      // Allow only alphanumeric characters (no spaces)
      if (!/[0-9a-zA-Z]/i.test(event.key)) {
        event.preventDefault();
      }
    });

    el.addEventListener("paste", function (event) {
  event.preventDefault();
  const target = event.target;
  const clipboardData = event.clipboardData || window.clipboardData;
  const rawPastedText = clipboardData.getData("text");

  // Strip anything that isn't alphanumeric instead of rejecting the whole paste
  const pastedText = rawPastedText.replace(/[^a-zA-Z0-9]/g, "");

  if (pastedText.length > 0) {
    const current = target.value || "";
    const start = target.selectionStart;
    const end = target.selectionEnd;
    const maxLength = target.maxLength;
    const availableLength =
      maxLength >= 0
        ? maxLength - (current.length - (end - start))
        : pastedText.length;
    const textToInsert = pastedText.slice(0, Math.max(0, availableLength));
    target.value =
      current.substring(0, start) + textToInsert + current.substring(end);
    const newCursorPosition = start + textToInsert.length;
    target.setSelectionRange(newCursorPosition, newCursorPosition);
    target.dispatchEvent(new Event("input", { bubbles: true }));
  }
});

    el.addEventListener("input", function (event) {
      const target = event.target;
      const currentValue = target.value || "";
      // Remove anything that is not alphanumeric.
      // This also handles fake filler/autofill/programmatic input
      // when an input event is triggered.
      const sanitizedValue = currentValue.replace(/[^a-zA-Z0-9]/g, "");
      if (currentValue !== sanitizedValue) {
        const cursorPosition = target.selectionStart;
        target.value = sanitizedValue;
        // Keep cursor position reasonable after removing characters
        const newCursorPosition = Math.min(cursorPosition, sanitizedValue.length);
        target.setSelectionRange(newCursorPosition, newCursorPosition);
        target.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  },
};

export const claimRate = {
  mounted(el) {
    const allowedKeys = [
      "Backspace", "Delete",
      "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      "Tab", "Home", "End",
    ];

    el.addEventListener("keydown", (event) => {
      const isNumeric = /^[0-9]$/.test(event.key);
      const isDot = event.key === "." || event.key === "Decimal";
      const isAllowedKey = allowedKeys.includes(event.key);
      const isCtrlCombo =
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].includes(event.key.toLowerCase());

      // Block anything that's not a digit, dot, nav key, or ctrl combo
      if (!isNumeric && !isDot && !isAllowedKey && !isCtrlCombo) {
        event.preventDefault();
        return;
      }

      if (isDot) {
        // Block leading dot or duplicate dot
        if (el.value === "" || el.value.includes(".")) {
          event.preventDefault();
        }
        return;
      }

      if (isNumeric) {
        const selStart = el.selectionStart;
        const selEnd = el.selectionEnd;
        const newValue =
          el.value.slice(0, selStart) + event.key + el.value.slice(selEnd);
        const parts = newValue.split(".");
        // Block if it would result in more than 2 decimal places
        if (parts.length === 2 && parts[1].length > 2) {
          event.preventDefault();
        }
      }
    });

    el.addEventListener("paste", (event) => {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData("text");

      // Strip non-numeric except one decimal, limit to 2 decimal places
      let cleaned = paste.replace(/[^0-9.]/g, "");
      const parts = cleaned.split(".");
      if (parts.length > 2) {
        cleaned = `${parts[0]}.${parts[1]}`;
      } else if (parts.length === 2) {
        cleaned = `${parts[0]}.${parts[1].slice(0, 2)}`;
      }

      if (cleaned !== "") {
        const selStart = el.selectionStart;
        const selEnd = el.selectionEnd;
        const newValue =
          el.value.slice(0, selStart) + cleaned + el.value.slice(selEnd);
        el.value = newValue;
        el.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  },
};

export const alphanumericwithspecial = {
  mounted(el) {
    // Allow: a-z, A-Z, 0-9, space, @ - / , .
    const allowedRegex = /^[a-zA-Z0-9@\-/,.\s]*$/;
    const singleKeyRegex = /[a-zA-Z0-9@\-/,.\s]/;

    el.addEventListener("keydown", function (event) {
      // Allow control keys
      const controlKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
      ];

      if (controlKeys.includes(event.key)) {
        return;
      }

      if (!singleKeyRegex.test(event.key)) {
        event.preventDefault();
      }
    });

    el.addEventListener("paste", function (event) {
      event.preventDefault();

      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");

      if (allowedRegex.test(pastedText)) {
        el.value += pastedText;
        el.dispatchEvent(new Event("input"));
      }
    });
  },
};
